export enum SERVER_RESPONSES {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  FAILURE = "FAILURE",
  ACCESS_DENIED = "ACCESS_DENIED"
}
